module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "background-image"
  }), _vm._v(" "), _c('main-toolbar'), _vm._v(" "), _c('el-row', {
    staticClass: "main__row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('main-projects')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-485e5e5d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/main.vue
// module id = 288
// module chunks = 0